import { BASE_URL } from './inquiries'; // BASE_URL still needed
import { fetchWithAuth } from './apiClient';

export const getCategories = async () => {
    const response = await fetch(`${BASE_URL}/api/cases/categories`);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return response.json();
};

export const getCases = async (categoryCode) => {
    let url = `${BASE_URL}/api/cases`;
    if (categoryCode && categoryCode !== 'ALL') {
        url += `?category=${categoryCode}`;
    }
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch cases');
    return response.json();
};

// Admin functions - Use fetchWithAuth
export const createCategory = async (data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases/categories`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create category');
    return response.json();
};

export const updateCategory = async (id, data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases/categories/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to update category');
    return response.json();
};

export const deleteCategory = async (id) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases/categories/${id}`, {
        method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete category');
    return response.json();
};

export const createCase = async (data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create case');
    return response.json();
};

export const updateCase = async (id, data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to update case');
    return response.json();
};

export const deleteCase = async (id) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases/${id}`, {
        method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete case');
    return response.json();
};

export const reorderCases = async (ids) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/cases/reorder`, {
        method: 'POST',
        body: JSON.stringify({ ids })
    });
    if (!response.ok) throw new Error('Failed to reorder cases');
    return response.json();
};
